const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const CopyTable = require("../../office/data/CopyTable");
const StepWrapper = require("./StepWrapper");
const RadioItem = require("../../office/RadioItem");
const Checkbox = require("../../core/view/Checkbox");

const styles = require("./styles/SetSettings.css");

module.exports = createReactClass({
	displayName: "SetLockScheme",

	propTypes: {
		studentData: PT.object.isRequired,
		copy: PT.object.isRequired,
		renderButton: PT.func.isRequired,
		handleSubmit: PT.func.isRequired,
		onChange: PT.func.isRequired,
		stepNumber: PT.number.isRequired,
		totalNumSteps: PT.number.isRequired,
		baLevel: PT.number.isRequired,
		handleBack: PT.func,
	},

	getInitialState: function() {
		const isSecondaryFlow =
			this.props.studentData?.primarySetupStep === "FINAL";

		// Pre-select lock scheme for secondary flow
		let initialLockScheme = null;
		let initialCheckboxes = {};

		if (isSecondaryFlow) {
			const currentLockSettings = this.props.studentData.parentLockSettings;
			// Default to "default" (Sequential) if no lock settings exist
			initialLockScheme = currentLockSettings?.scheme || "default";
			// Pre-select checkboxes if scheme is "all"
			if (initialLockScheme === "all" && currentLockSettings) {
				initialCheckboxes = {
					test: !!currentLockSettings.test,
					lab: !!currentLockSettings.lab,
				};
			}
		}

		return {
			lockScheme: initialLockScheme,
			checkboxesChecked: initialCheckboxes,
		};
	},

	chooseLockScheme: function(newLockScheme) {
		const newState = {lockScheme: newLockScheme};
		this.setState(newState);
		this.props.onChange();
	},

	toggleCheckBox: function(type) {
		this.setState({
			checkboxesChecked: {
				...this.state.checkboxesChecked,
				[type]: !this.state.checkboxesChecked[type],
			},
		});
	},

	handleSubmit: function() {
		this.props.handleSubmit({
			scheme: this.state.lockScheme,
			...(this.state.lockScheme === "all" ? this.state.checkboxesChecked : {}),
		});
	},

	renderOption: function(option) {
		const isSelected = option.key === this.state.lockScheme;
		let checkboxEls;
		if (option.checkboxTexts && isSelected) {
			checkboxEls = (
				<div className={styles.checkboxContainer}>
					{_.map(option.checkboxTexts, (text, k) => {
						const checkboxDesc = _.get(option, ["checkboxDescriptions", k]);
						const checkboxDescEl = checkboxDesc ? (
							<div className={styles.checkDesc}>{checkboxDesc}</div>
						) : null;
						return (
							<div key={"checkbox" + k}>
								{checkboxDescEl}
								<Checkbox
									className={
										isSelected ? styles.checkbox : styles.checkboxDisabled
									}
									text={text}
									disabled={!isSelected}
									isSelected={!!this.state.checkboxesChecked[k]}
									onClick={() => this.toggleCheckBox(k)}
								/>
							</div>
						);
					})}
				</div>
			);
		}
		return (
			<button
				className={styles.lockSchemeItemContainer}
				key={option.key + "RadioRow"}
				onClick={() => this.chooseLockScheme(option.key)}
			>
				<div className={styles.radioAndDescriptionContainer}>
					<div className={styles.radioItemContainer}>
						<RadioItem
							className={styles.radio}
							text={`${option.label}`}
							isSelected={isSelected}
							size={"large"}
							isDisabled={false}
							color={"blue"}
						/>
					</div>
					<div className={styles.radioDescription}>
						{option.shortDescription}
					</div>
				</div>
				{checkboxEls}
			</button>
		);
	},

	render: function() {
		const wrapperProps = _.pick(this.props, [
			"copy",
			"renderButton",
			"renderError",
			"stepNumber",
			"totalNumSteps",
			"handleBack",
		]);

		const lockInfo = CopyTable.getAccountOptions({
			styles,
			type: "lockSettings",
			studentName: this.props.studentData.displayName,
			baLevel: this.props.baLevel,
			isParent: true,
			isInitialSetup: true,
		});

		const radioRows = _.map(lockInfo.options, opt => this.renderOption(opt));

		return (
			<StepWrapper {...wrapperProps} handleSubmit={this.handleSubmit}>
				{radioRows}
			</StepWrapper>
		);
	},
});
